module.exports = __webpack_public_path__ + "static/media/circo_2016_logo.ebd7a37a.png";